<template>
  <form @submit.prevent="submitEmitter">
    <div class="emd-panel">
      <emd-address-brazilian-form
        v-model="form"
        ref="formComponent"
        :searchZipCodeIsAllowed="searchZipCode"
      />
    </div>
  </form>
</template>
<script>
import { EmdAddressBrazilianForm } from 'emerald-vue/src/components'
import PhysicalWorldFormDTO from '../PhysicalWorldFormDTO'
export default {
  name: 'FormAddress',
  props: {
    initialValues: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    searchZipCode: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      form: {
        city: '',
        complement: '',
        country: 'Brasil',
        neighborhood: '',
        number: '',
        state: '',
        street: '',
        zip_code: ''
      },
      formAddressIsInvalid: true
    }
  },
  components: {
    EmdAddressBrazilianForm
  },
  methods: {
    submitEmitter () {
      this.$refs.formComponent.$v.value.$touch()
      this.formAddressIsInvalid = this.$refs.formComponent.$v.value.$invalid

      if (!this.formAddressIsInvalid) {
        new PhysicalWorldFormDTO().addItem({
          address: {
            ...this.form,
            reference: this.form.complement
          }
        })
      }

      return new PhysicalWorldFormDTO().setError(this.formAddressIsInvalid)
    }
  },
  mounted () {
    this.form = { ...this.form, ...this.initialValues }
    if (this.disabled) {
      this.$refs.formComponent.$el.querySelectorAll('input').forEach(input => {
        input.setAttribute('disabled', true)
      })
    }
  }
}
</script>
